/**
 * SASADM-0174 — saas-auth serializes a field's key (even as null) once the release that adds it is
 * deployed; until then the key is absent and writes to it are silently ignored. Show a control only
 * when a read carries its key (saas-auth handoff 2026-10-13 §2). No flags, no version checks.
 */
export function hasKey(obj: object | null | undefined, key: string): boolean {
  return obj != null && Object.prototype.hasOwnProperty.call(obj, key);
}

/** True when ANY of the rows carries the key — the rows come from one saas-auth deployment. */
export function anyHasKey(rows: readonly object[] | null | undefined, key: string): boolean {
  return (rows ?? []).some((r) => hasKey(r, key));
}

/** SASATH-0390's app keys. */
export const APP_KEYS_0390 = [
  'siteType',
  'cspScriptSrc',
  'cspConnectSrc',
  'cspFormAction',
] as const;
export type AppKey0390 = (typeof APP_KEYS_0390)[number];

/** SASADM-0179 — SASATH-0397's app keys: style and font sources. */
export const APP_KEYS_0397 = ['cspStyleSrc', 'cspFontSrc'] as const;
export type AppKey0397 = (typeof APP_KEYS_0397)[number];
